module.exports = __webpack_public_path__ + "static/img/icon_jinhua_s@2x.fbbcce9c.png";